<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'INTERNATIONALIZATION' }
  ]"
></breadcrumbs>

<page-header title="INTERNATIONALIZATION"></page-header>

<div class="m-3">
  <app-tabset (tabChange)="onTabChange($event)">
    <app-tab
      *ngFor="let lang of languages$ | async"
      [id]="lang.iso2code"
      [name]="lang.name"
      [active]="currentLanguage === lang.iso2code"
    >
      <app-table
        [isLoading]="isLoading"
        [totalItems]="state.get('total')"
        [totalResults]="state.get('results')"
        [itemsPerPage]="getQueryParam('page_size')"
        [rows]="state.get('data')"
        [currentPage]="getQueryParam('page')"
        (onPageChange)="handlePageChange($event)"
        (onPageSizeChange)="handlePageSizeChange($event)"
        (onSort)="handleSort($event)"
        [sort]="getQueryParam('sort')"
        [orderBy]="getQueryParam('order_by')"
        [columns]="columns"
      >
        <ng-template #addonLeft>
          <div class="buttons mb-0">
            <a
              [routerLink]="['../', 'crud']"
              class="button is-small is-info mb-0"
              translationEditableDirective="CREATE_TRANSLATION"
              >{{ 'CREATE_TRANSLATION' | translate }}</a
            >
            <a
              class="button is-small is-info mb-0"
              (click)="export()"
              translationEditableDirective="EXPORT"
              >{{ 'EXPORT' | translate }}</a
            >
            <button
              class="button is-success is-small p-0 has-text-white mb-0"
              style="width: 25px"
              title="{{ 'IMPORT' | translate }}"
              (click)="importModalVisible = true"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18px"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" />
              </svg>
            </button>
          </div>
        </ng-template>
        <ng-template #addonRight>
          <form>
            <input
              class="input is-small"
              type="text"
              name="keyword"
              [placeholder]="'SEARCH' | translate"
              [translationEditableModalDirective]="['SEARCH']"
              (input)="handleFilterChange($event)"
              [value]="getQueryParam('keyword')"
            />
          </form>
        </ng-template>
        <ng-template let-row="row" #actionsColumn>
          <div class="buttons">
            <a
              [routerLink]="['../', 'crud', row.get('key')]"
              [queryParams]="{ value: row.get('value') }"
              class="button is-small"
              translationEditableDirective="UPDATE"
              >{{ 'UPDATE' | translate }}</a
            >
            <alert
              #deleteAlert
              (confirm)="deleteTranslation(row.get('key'))"
              titleTrnKey="ARE_YOU_SURE"
              textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
            />
            <button
              class="button is-danger is-small"
              (click)="deleteAlert.fire()"
              translationEditableDirective="DELETE"
            >
              {{ 'DELETE' | translate }}
            </button>
          </div>
        </ng-template>
      </app-table>
    </app-tab>
  </app-tabset>
</div>

<div class="modal is-active" *ngIf="importModalVisible">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <span class="modal-card-title" translationEditableDirective="IMPORT">{{
        'IMPORT' | translate
      }}</span>
      <button
        class="delete"
        (click)="importModalVisible = false"
        aria-label="close"
      ></button>
    </div>
    <form (submit)="import($event)">
      <div class="modal-card-body">
        <div class="field is-narrow">
          <label class="label" translationEditableDirective="FILE">{{
            'FILE' | translate
          }}</label>
          <div class="control">
            <input
              name="file"
              class="input"
              accept=".json"
              [formControl]="importForm"
              type="file"
            />
          </div>
        </div>
      </div>

      <footer class="modal-card-foot">
        <button
          class="button is-success"
          type="submit"
          translationEditableDirective="IMPORT"
        >
          {{ 'IMPORT' | translate }}
        </button>
        <button
          class="button"
          (click)="importModalVisible = false"
          translationEditableDirective="CANCEL"
        >
          {{ 'CANCEL' | translate }}
        </button>
      </footer>
    </form>
  </div>
</div>
